import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BaseButton from "../../main/components/BaseButton";
import { useContext } from "react";
import { MainContext } from "../../main/context/MainContextProvider";

export default function SuccessMessage() {
  const { setUser } = useContext(MainContext);
  const navigate = useNavigate();

  const isPasswordRecovery =
    window.location.pathname.includes("/recuperar-senha");
  const isFirstAccess = window.location.pathname.includes("/nova-senha");

  const handleButtonBack = () => {
    setUser(undefined);
    navigate("/login");
  };

  return (
    <Grid
      container
      spacing={2}
      rowGap={2}
      justifyContent="center"
      maxWidth={"400px"}
    >
      <Grid
        item
        xs={10}
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
        container
        direction="column"
      >
        <Typography variant="h4" color="#387D27">
          Sucesso!
        </Typography>
      </Grid>
      <Grid item xs={10}>
        <Typography>
          {isPasswordRecovery &&
            "Foi enviado um e-mail para o endereço informado com as instruções para a recuperação de senha."}
          {isFirstAccess && "Senha alterada com sucesso."}
        </Typography>
      </Grid>
      <Grid xs={10} item justifyContent="center">
        <BaseButton
          type="button"
          onClick={() => handleButtonBack()}
          title="Voltar para tela de login"
        />
      </Grid>
    </Grid>
  );
}
